var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "06AE247D-3FB0-42F7-9A70-35E72EE46C36") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio-builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5-client-profile",
    transform: "translate(-405.000000, -361.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-area",
    transform: "translate(60.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "client-profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(16.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attributes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "costs",
    transform: "translate(288.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(6.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(35.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/viewfinder/performance"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/costs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C3.12298149,0 0,3.1231538 0,7 C0,10.8768462 3.1231538,14 7,14 C10.8768462,14 14,10.8768462 14,7 C14,3.1231538 10.8768462,0 7,0 Z",
    id: "Shape",
    fill: "#F6AA33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06488345,6.33090391 C6.78280725,6.22796225 6.4537334,6.12502059 6.38320682,5.97059163 C6.33619412,5.86764997 6.28918142,5.68750041 6.50073707,5.5330978 C7.01789181,5.14705834 7.51151764,5.50736239 7.58204421,5.55883322 C7.79359986,5.71324571 8.07567004,5.68750865 8.24022202,5.45589156 C8.40477399,5.22427447 8.35775226,4.91545607 8.14619662,4.73529993 C7.95814582,4.58088744 7.65257079,4.42647495 7.27646919,4.34926047 L7.27646919,4.0147083 C7.27646919,3.73161709 7.06491354,3.5 6.80634219,3.5 C6.54777083,3.5 6.33621519,3.73161709 6.33621519,4.0147083 L6.33621519,4.45220213 C6.21868494,4.50367296 6.07764383,4.58087756 5.96011358,4.68381922 C5.44295884,5.06985868 5.25490804,5.76469019 5.51348541,6.38234015 C5.77205677,6.97426294 6.33621519,7.15441908 6.78284336,7.3088151 C7.34699576,7.51469842 7.4880489,7.59190631 7.51154773,7.8235234 C7.53505408,8.08087756 7.46453503,8.26101723 7.27648423,8.36395889 C6.94738029,8.56984221 6.33623023,8.51837138 6.00712628,8.23528346 C5.79557064,8.05513391 5.51350046,8.10660803 5.34894848,8.33822512 C5.18439651,8.56984221 5.23141824,8.87866061 5.44297388,9.05881675 C5.70154524,9.26470007 6.00712628,9.39336891 6.33623023,9.47058339 L6.33623023,9.9852917 C6.33623023,10.2683829 6.54778588,10.5 6.80635723,10.5 C7.06492858,10.5 7.27648423,10.2683829 7.27648423,9.9852917 L7.27648423,9.47058339 C7.44103019,9.41911256 7.60558818,9.36764173 7.77011006,9.26470007 C8.26373589,8.95587509 8.52231326,8.4154396 8.4753156,7.74630234 C8.40479505,6.76834009 7.60558818,6.5110024 7.0649346,6.33084626 L7.06488345,6.33090391 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCost);
export default __webpack_public_path__ + "static/media/view_cost.07988d0bc5b7ca4a0fed16b4d35058b4.svg";
export { ForwardRef as ReactComponent };